import getUrl from './getUrl.js';

export default function paymentMethods() {
  return fetch(`${getUrl()}/v2/transaction/payment-methods`, {
    method: 'GET',
    headers: {
      'Content-type':'application/json'
    },
    credentials: 'include',
  })
  .then((res) => res.json())
}